// extracted by mini-css-extract-plugin
module.exports = {"index":"notice-wrap_index_3Od3H"};